// extracted by mini-css-extract-plugin
module.exports =  {"priceWrapper":"ScreenerCell-module__priceWrapper--nZSNZ","unit":"ScreenerCell-module__unit--sXLnr"};